export default {
  //----- LIBRARY PREDEFINED OPTIONS -----------------------------------------------------------------------

  //----- ANIMALS -----------------------------------------------------------------------

  // CONSERVATION STATUS
  OPTIONS_CONSERVATION_STATUS: [
    "Least Concern",
    "Near Threatened",
    "Vulnerable",
    "Endangered",
    "Critically Endangered",
    "Extinct in the Wild",
    "Extinct",
    "Data Deficient",
    "Not Evaluated",
  ],

  //----- PEOPLE -----------------------------------------------------------------------

  // NATIONALITY
  OPTIONS_NATIONALITY: [
    "Namibian",
    "South African",
    "Angolan",
    "Botswanan",
    "Zimbabwean",
    "German",
    "British",
    "Portuguese",
    "Dutch",
    "French",
  ],
  // REGION
  OPTIONS_REGION: [
    "Erongo",
    "Hardap",
    "Karas",
    "Kavango East",
    "Kavango West",
    "Khomas",
    "Kunene",
    "Ohangwena",
    "Omaheke",
    "Omusati",
    "Oshana",
    "Oshikoto",
    "Otjozondjupa",
  ],
  // PROFESSION/ROLE
  OPTIONS_ROLE: [
    "Artist",
    "Conservationist",
    "Educator",
    "Explorer",
    "Historian",
    "Leader",
    "Musician",
    "Politician",
    "Religious Figure",
    "Scientist / Researcher",
    "Writer / Author",
  ],
  // TRADITIONAL LIFESTYLE
  OPTIONS_TRADITIONAL_LIFESTYLE: [
  "Semi-nomadic cattle herders",
  "Pastoralist (livestock herding)",
  "Agricultural (farming)",
  "Hunter-gatherer",
  "Fishing community",
  "Urbanized/Settled"
],
};
